import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../Context/ConfigContext';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart } from '../Redux/features/Cart/CartSlice';
import { ToastContainer, toast } from 'react-toastify';
import { formatSlug } from '../Utils/Helper';
import GlobalCards from '../Utils/GlobalCards';
import CardShimmer from '../Utils/shimmerEffect/CardShimmer';

const PopularProducts = () => {
    const { apiURL } = useContext(ConfigContext);
    const dispatch = useDispatch()
    const wishList = useSelector(state => state.Wishlist)
    const navigate = useNavigate()
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandedId, setExpandedId] = useState(null);

    const GetProducts = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${apiURL}Home/GetHomeProducts`, { params: { limit: 5 } });
            setData(response?.data?.data?.data);
            setLoading(false)
        } catch (error) {
            console.error(error)
        }
    };

    const toggleExpansion = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    const PageRoute = () => {
        navigate("/AllProductsList")
    }

    const handleAddToCart = (product) => {
        dispatch(addToCart(product))
        toast.success(`${product.product_title} Added`, {
            position: "bottom-center",
        })
    }

    const CheckWishList = (product_id) => {
        return wishList.some((item) => item.product_id === product_id);
    }

    const handleProductDetails = (product) => {
        if (product) {
            navigate(`/ProductDetails/${formatSlug(product.product_title)}=${product.product_id}`)
        }
    }

    useEffect(() => {
        GetProducts();
    }, []);

    return (
        <>
            <ToastContainer />
            <section className="product-tabs section-padding position-relative">
                <div className="container">
                    <div className="section-title style-2 wow animate__animated animate__fadeIn mb-30">
                        <h3>Popular Products</h3>
                        <ul className="nav nav-tabs links" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <Link to="/AllProductsList">
                                    <button onClick={PageRoute} className="nav-link active" id="nav-tab-one" data-bs-toggle="tab" data-bs-target="#tab-one" type="button" role="tab" aria-controls="tab-one" aria-selected="true">
                                        All Popular Products
                                    </button>
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="tab-one" role="tabpanel" aria-labelledby="tab-one">
                            <div className="row product-grid-4">
                                {loading
                                    ? Array.from({ length: 5 }).map((_, i) => <CardShimmer key={i} />)
                                    : data.map((item, i) => (
                                        // <div key={item.product_id} className="col-lg-1-5 col-md-4 col-12 col-sm-6" >
                                        //     <div className="product-cart-wrap mb-30 wow animate__animated animate__fadeIn" data-wow-delay=".1s">
                                        //         <div className="product-img-action-wrap">
                                        //             <div className="product-img product-img-zoom">
                                        //                 <a>
                                        //                     <img
                                        //                         className="default-img"
                                        //                         onClick={() => handleProductDetails(item)}
                                        //                         src={item.product_image_url}
                                        //                         loading='lazy'
                                        //                         alt=""
                                        //                     />
                                        //                     <img
                                        //                         className="hover-img"
                                        //                         onClick={() => handleProductDetails(item)}
                                        //                         src={item.product_image_url}
                                        //                         loading='lazy'
                                        //                         alt=""
                                        //                     />
                                        //                 </a>
                                        //             </div>
                                        //             <div className="product-action-1">
                                        //                 {
                                        //                     CheckWishList(item.product_id) === true ?
                                        //                         (
                                        //                             <a
                                        //                                 onClick={() => dispatch(removeWishListItem(item.product_id))}
                                        //                                 aria-label={`Remove From Wishlist`} className="action-btn"
                                        //                                 style={{ background: '#FDC040' }} >
                                        //                                 <i style={{ color: '#fff' }} className="fi-rs-heart" />
                                        //                             </a>
                                        //                         ) :
                                        //                         <a
                                        //                             onClick={() => dispatch(addToWishList(item))}
                                        //                             aria-label={`Add To Wishlist`}
                                        //                             className="action-btn" >
                                        //                             <i className="fi-rs-heart" />
                                        //                         </a>
                                        //                 }
                                        //             </div>
                                        //             <div className="product-badges product-badges-position product-badges-mrg">
                                        //                 {
                                        //                     item?.product_label &&
                                        //                     <span className={item?.product_label_class}>{item?.product_label}</span>
                                        //                 }
                                        //             </div>
                                        //         </div>
                                        //         <div className="product-content-wrap" >
                                        //             <div className="product-description">
                                        //                 <h2>
                                        //                     <a>
                                        //                         <div
                                        //                             onClick={() => handleProductDetails(item)}
                                        //                             className={`expandable-text`}
                                        //                             // style={{ marginTop: "20" }}
                                        //                         >
                                        //                             {item.product_title}
                                        //                         </div>
                                        //                     </a>
                                        //                 </h2>
                                        //             </div>
                                        //             <div className="product-rate-cover">
                                        //                 <div className="product-rate d-inline-block">
                                        //                     <div className="product-rating" style={{ width: '90%' }} />
                                        //                 </div>
                                        //                 <span className="font-small ml-5 text-muted"> (4.0)</span>
                                        //             </div>
                                        //             <div>
                                        //                 <span className="font-small text-muted">Specification :  <a>
                                        //                     {item.product_short_description.slice(0, 30) + (item.product_short_description.length > 30 ? "..." : "")}
                                        //                 </a>
                                        //                 </span>
                                        //             </div>
                                        //             <div className="product-card-bottom">
                                        //                 {item.product_stock_status !== 0 && (
                                        //                     <div className="product-price">
                                        //                         <span>₹ {item.product_variant_sale_price}</span>
                                        //                         <span className="old-price">₹ {item.product_variant_mrp_price}</span>
                                        //                     </div>
                                        //                 )}
                                        //                 <div className="add-cart">
                                        //                     {item.product_stock_status === 0 ? (
                                        //                         <span className="stock-status out-stock mb-0"> Out Stock </span>
                                        //                     ) : (
                                        //                         <span className="add" onClick={() => handleAddToCart(item)}>
                                        //                             <i className="fi-rs-shopping-cart mr-5" />Add
                                        //                         </span>
                                        //                     )}
                                        //                 </div>
                                        //             </div>
                                        //         </div>
                                        //     </div>
                                        // </div>

                                        <GlobalCards
                                            item={item}
                                            handleProductDetails={() => handleProductDetails(item)}
                                            handleAddToCart={handleAddToCart}
                                            CheckWishList={CheckWishList(item?.product_id)}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>
    );
};

export default PopularProducts;
